import script from "./TagSearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TagSearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./TagSearchInput.vue?vue&type=style&index=0&id=34b985ee&lang=scss"

const __exports__ = script;

export default __exports__